<template lang="jade">
  lightbox(":open"="open"
           ":title"="title.value"
           ":loading"="loading")
    div(slot="Lightbox__body")
      slot(name="content")
</template>
<script>
  import lightbox from 'src/components/dialogs/lightbox'
  import _ from 'lodash'
  import { forms } from 'src/vuex/getters'

  export default {
    data () {
      return {
        uid: this.$parent.uid,
        open: true
      }
    },

    props: {
      loading: {
        type: Boolean,
        default: false
      }
    },

    computed: {

      form () {
        return _.find(this.forms, ['uid', this.uid])
      },

      title () {
        return _.find(this.form.fields, ['type', 'type_title'])
      }

    },

    components: {
      lightbox
    },

    vuex: {
      getters: {
        forms
      }
    }
  }
</script>



// WEBPACK FOOTER //
// modal.vue?149197d6